'use strict';

var twentyninetimes = twentyninetimes || {};

twentyninetimes.tabbed = twentyninetimes.tabbed || function () {

    function init() {
        tabbedContent();
    }

    function tabbedContent(){


            let tabbedElements = document.querySelectorAll('.tabbed-js');
                        
            if (tabbedElements.length) {
                tabbedElements.forEach(function(thisTabbed) {
                    var navItems = thisTabbed.querySelectorAll('.tabbed-nav ul li');

                    navItems.forEach(function(navItem) {
                        navItem.addEventListener('click', function(e) {
                            thisTabbed.querySelector('.tabbed-nav ul li.active').classList.remove('active');
                            thisTabbed.querySelector('.block-tabbed-content-item.active').classList.remove('active');
                            var target = navItem.dataset.target;
                            thisTabbed.querySelector(target).classList.add('active');
                            navItem.classList.add('active');
                        });
                    });
                });
            }
    }


    return {
        init:init
    };


}();